// extracted by mini-css-extract-plugin
export default {"pleadingSuccess":"SourceDocumentReview_pleadingSuccess__cYaia"};